import { MediaMatcher } from '@angular/cdk/layout';
import { DOCUMENT, Location } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { BaseMaterialLayoutComponent } from 'src/app/shared/components/base';

@Component({
  selector: 'app-page-not-found-layout',
  templateUrl: './page-not-found-layout.component.html',
  styleUrls: ['./page-not-found-layout.component.scss'],
})
export class PageNotFoundLayoutComponent extends BaseMaterialLayoutComponent implements OnInit {
  constructor(
    @Inject(DOCUMENT) protected override document: Document,
    protected override media: MediaMatcher,
    private location: Location
  ) {
    super(document, media);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.loaderService.setLoadingFullScreen(false);
  }

  public returnToPreviousPage(): void {
    this.location.back();
  }
}
